import { Einblenden, Etikett } from './Bausteine'
import { konferenz, studio } from '@/data/inhalte'

/** Foto aus den FOM Studios (Bestand der DLS-Seite, fom-dls-story/assets/img/lehre-panel). */
export default function Studio() {
  return (
    <section id="studio" className="relative isolate overflow-hidden bg-konf-nacht text-white">
      <img
        src="/img/studio-podium.webp"
        alt="Podiumsgespräch in den FOM Studios"
        loading="lazy"
        className="absolute inset-0 -z-10 h-full w-full object-cover object-[60%_center]"
      />
      <div aria-hidden="true" className="absolute inset-0 -z-10 bg-[linear-gradient(0deg,rgba(0,30,43,.95)_0%,rgba(0,30,43,.55)_55%,rgba(0,30,43,.15)_100%)] lg:bg-[linear-gradient(90deg,rgba(0,30,43,.94)_0%,rgba(0,30,43,.62)_42%,rgba(0,30,43,.05)_100%)]" />
      <div className="huelle flex min-h-[78svh] items-end py-16 sm:py-24 lg:items-center">
        <Einblenden className="max-w-[540px]">
          {/* Umbruch nur zwischen Datum und Uhrzeit, nie mitten in der Uhrzeit */}
          <Etikett aufDunkel>
            <span className="whitespace-nowrap">{konferenz.datum}</span> · <span className="whitespace-nowrap">{konferenz.uhrzeit}</span>
          </Etikett>
          <h2 className="mt-8 text-[clamp(32px,4.2vw,54px)]">{studio.titel}</h2>
        </Einblenden>
      </div>
    </section>
  )
}
